import api from "../../api/api";
import { ChannelLanguagePairData, ProductId } from "../product";

export type SendToProofreadingRequest = {
  channel_language_pairs: ChannelLanguagePairData[];
  email_delivery: string;
  source_language: string;
  additional_instructions: string;
  is_urgent: boolean;
};

export type SendToProofreadingResponse = {
  message: string;
};

export type BulkSendToProofreadingRequest = SendToProofreadingRequest & {
  bucket: string;
};

export async function sendProductToProofreading(
  token: string,
  productId: ProductId,
  payload: SendToProofreadingRequest
): Promise<SendToProofreadingResponse> {
  const response = await api.post(
    `/api/_internal/product/${productId}/send_to_proofreading/`,
    payload,
    { headers: { token: token } }
  );
  return response.data;
}

export async function sendBulkToProofreading(
  token: string,
  payload: BulkSendToProofreadingRequest
): Promise<SendToProofreadingResponse> {
  const response = await api.post(
    `/api/_internal/product/bulk_send_to_proofreading/`,
    payload,
    { headers: { token: token } }
  );
  return response.data;
}
